<div class="modal-header">
  <span i18n="@@edit-group">Projektgruppe bearbeiten</span>
</div>
<div class="modal-body">
  <app-picklist
    [items]="this.permissionService.selectableGroupUsers"
    [pickedItems]="this.permissionService.groupUsers"
    [bindLabel]="'name'"
    [bindValue]="'userId'"
    (itemsPicked)="this.permissionService.assignUsersToGroup($event)"
    (itemsUnpicked)="this.permissionService.revokeUsersFromGroup($event)"
  ></app-picklist>
</div>